// 2020-07-16export { TropaCorralNotificacionComponent } from './tropa-corral-notificacion.component';